/* VTILTED storefront audit fixes — 2026-08-24 */
(function () {
  'use strict';

  function updateInstallmentVariant(variant) {
    if (!variant || !variant.id) return;
    var form = document.getElementById('product-form-installment-top');
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;
    input.value = variant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncNotifyButtons() {
    var soldOut = (window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut) || 'Sold Out';
    var addToCart = (window.theme && window.theme.variantStrings && window.theme.variantStrings.addToCart) || 'Add to cart';
    var preOrder = (window.theme && window.theme.variantStrings && window.theme.variantStrings.preOrder) || 'Pre-order';

    document.querySelectorAll('.single-add-to-cart-button').forEach(function (button) {
      var label = button.querySelector('.single-add-to-cart-button--text');
      if (!label) return;
      var text = (label.textContent || '').trim();

      if (text === soldOut || text.toLowerCase() === 'sold out') {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.setAttribute('type', 'button');
        button.classList.remove('loading');
        button.classList.add('js-notify-me', 'sold-out');
        label.textContent = 'Notify Me';
      } else if (text === addToCart || text === preOrder) {
        button.classList.remove('js-notify-me', 'sold-out');
        button.setAttribute('type', 'submit');
      }

      if (!button.__vtNotifyObserver) {
        button.__vtNotifyObserver = new MutationObserver(function () {
          syncNotifyButtons();
        });
        button.__vtNotifyObserver.observe(label, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  function fixHomepageAllProductsLink() {
    var card = document.querySelector('.vt-collections__link[aria-label="ALL PRODUCTS"]');
    if (card && card.getAttribute('href') === '/collections/new-arrivals') {
      card.setAttribute('href', '/collections/new-arrivals-copy');
    }
  }

  function fallbackCopy(value) {
    var area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try { document.execCommand('copy'); } catch (e) {}
    area.remove();
  }

  function bindFooterCopyButton(button, email) {
    if (!button || button.dataset.vtCopyReady === 'true') return;
    button.dataset.vtCopyReady = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var done = function () {
        button.textContent = 'COPIED';
        window.setTimeout(function () { button.textContent = 'COPY'; }, 1600);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(email).then(done).catch(function () {
          fallbackCopy(email);
          done();
        });
      } else {
        fallbackCopy(email);
        done();
      }
    });
  }

  function fixFooterEmailCopy() {
    var footer = document.getElementById('footer');
    var link = footer && footer.querySelector('.vt-footer-orders-link');
    if (!footer || !link) return;

    var email = 'vtiltedapparel@gmail.com';
    link.removeAttribute('href');
    link.removeAttribute('target');
    link.removeAttribute('rel');
    link.setAttribute('aria-label', 'VTILTED email address');

    var buttons = Array.prototype.slice.call(footer.querySelectorAll('.vt-footer-copy-email'));
    var button = link.querySelector('.vt-footer-copy-email') || buttons[0];

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-footer-copy-email';
      button.textContent = 'COPY';
      button.setAttribute('aria-label', 'Copy VTILTED email address');
    }

    if (button.parentNode !== link) link.appendChild(button);

    buttons.forEach(function (candidate) {
      if (candidate !== button) candidate.remove();
    });

    /* Clean up any older duplicate button that may not carry the current class. */
    footer.querySelectorAll('button').forEach(function (candidate) {
      if (candidate !== button && (candidate.textContent || '').trim().toUpperCase() === 'COPY') {
        candidate.remove();
      }
    });

    bindFooterCopyButton(button, email);

    if (!link.dataset.vtCopyLinkReady) {
      link.dataset.vtCopyLinkReady = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
      });
    }
  }

  function init() {
    syncNotifyButtons();
    fixHomepageAllProductsLink();
    fixFooterEmailCopy();
  }

  document.addEventListener('product:variant-change', function (event) {
    updateInstallmentVariant(event.detail && event.detail.variant);
    window.setTimeout(syncNotifyButtons, 0);
  });

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
